import { cn } from '@/lib/utils/cn';

const COUNTRIES = [
  { code: 'JO', name: 'Jordan', flag: '🇯🇴' },
  { code: 'SA', name: 'Saudi Arabia', flag: '🇸🇦' },
  { code: 'AE', name: 'UAE', flag: '🇦🇪' },
  { code: 'EG', name: 'Egypt', flag: '🇪🇬' },
] as const;

interface CountrySelectProps {
  value: string;
  onChange: (code: string) => void;
  className?: string;
  placeholder?: string;
}

export function CountrySelect({ value, onChange, className, placeholder = 'All Countries' }: CountrySelectProps) {
  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className={cn(
        'rounded-lg border border-border bg-surface px-3 py-1.5 text-sm text-fg',
        'focus:outline-none focus:ring-2 focus:ring-primary-500/30',
        className,
      )}
    >
      <option value="">{placeholder}</option>
      {COUNTRIES.map(({ code, name, flag }) => (
        <option key={code} value={code}>
          {flag} {name}
        </option>
      ))}
    </select>
  );
}
